// import { Tab } from "@headlessui/react";
// import { PencilAltIcon } from "@heroicons/react/outline";
import React, { FC, useState, useEffect } from "react";
// import visaPng from "images/vis.png";
// import mastercardPng from "images/mastercard.svg";
// import Input from "shared/Input/Input";
// import Label from "components/Label/Label";
// import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import { RootState } from "store";
import FormItem from "containers/PageAddListing1/FormItem";
// import ButtonSecondary from "shared/Button/ButtonSecondary";
import Modal from "shared/Modal";
// import Address from "components/Address";
import { useDispatch, useSelector } from "react-redux";
import { AddressType } from "data/types";
import { addAddress } from "actions/addressActions";
import { payOrder } from "actions/orderActions";
import moment from "moment";
import { useHistory } from "react-router-dom";
// import ListBox from "shared/Listbox/ListAddress";
import Error from "shared/Error";
// import Input from "shared/Input/Input";
import formatRupiah from "utils/toRupiah";
import Input from "shared/Input/Input";
import Loading from "shared/Loading";
import { ArrowRightIcon } from "@heroicons/react/outline";
import ButtonCircle from "shared/Button/ButtonCircle";
import axios from "axios";
import { calculateCoupon } from "utils/calculateCoupon";
import { ICoupon } from "types/interfaces";
import { getSingleProduct } from "actions/productActions";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { RentripsURL } from "utils/request";

interface ILocation {
  name: string;
  price: number;
}

const dummyPickup = [
  { name: "Bandara", price: 20000 },
  { name: "Krisna", price: 10000 },
  { name: "Bypass", price: 0 },
];

export interface CheckOutPageProps {
  className?: string;
}

interface ICouponProps {
  value: string;
  error: string;
  loading: boolean;
}

const CheckOutPage: FC<CheckOutPageProps> = ({ className = "" }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { singleProduct: thing } = useSelector(
    (state: RootState) => state.productSingle
  );

  const [open, setOpen] = useState<boolean>(false);
  const [courier, setCourier] = useState<string>("Kurir Toko");
  const [coupon, setCoupon] = useState<ICouponProps>({
    value: "",
    error: "",
    loading: false,
  });
  const [validCoupon, setValidCoupon] = useState<ICoupon>({
    _id: "",
    code: "",
    description: "",
    maxAmount: 0,
    minRequirement: 0,
    name: "",
    percentage: 0,
  });
  // eslint-disable-next-line
  const [alert, setAlert] = useState<boolean>(false);
  //eslint-disable-next-line
  const { loading, ongoingOrder, error, success } = useSelector(
    (state: RootState) => state.ongoingOrder
  );

  const [pickUp, setPickUp] = useState<ILocation>({ name: "", price: 0 });
  const [dropOff, setDropOff] = useState<ILocation>({ name: "", price: 0 });
  const [total, setTotal] = useState<number>(0);

  // eslint-disable-next-line
  const handleAddAddress = (e: AddressType) => {
    dispatch(addAddress(e));
    setOpen(!open);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleCoupon = async () => {
    try {
      setCoupon({ ...coupon, loading: true });
      if (!coupon.value)
        return setCoupon({
          ...coupon,
          loading: false,
          error: "Masukkan kode kupon anda",
        });

      const { data }: { data: ICoupon } = await axios.get(
        RentripsURL +`/api/coupon/${coupon.value.toUpperCase()}`
      );

      if (data) {
        setCoupon({ ...coupon, loading: false, error: "" });
        setValidCoupon(data);
      }
    } catch (error: any) {
      setCoupon({
        ...coupon,
        loading: false,
        error: error.response.data.message,
      });
    }
  };

  useEffect(() => {
    setPickUp(dummyPickup[0]);
    setDropOff(dummyPickup[0]);
  }, []);

  useEffect(() => {
    if (!ongoingOrder) {
      return history.push("/");
    }
    if (success) {
      return history.push(`/transaction/${ongoingOrder._id}`);
    }
    dispatch(getSingleProduct(ongoingOrder.productId));
  }, [ongoingOrder, success]);

  useEffect(() => {
    if (!ongoingOrder) return;
    setTotal(
      thing.price * ongoingOrder.days +
        3000 +
        pickUp.price +
        dropOff.price -
        calculateCoupon(
          thing.price,
          validCoupon.percentage,
          validCoupon.minRequirement,
          validCoupon.maxAmount
        )
    );
  }, [thing, pickUp, dropOff, validCoupon]);

  const handlePayment = () => {
    dispatch(
      payOrder(
        pickUp,
        dropOff,
        validCoupon._id,
        calculateCoupon(
          thing.price,
          validCoupon.percentage,
          validCoupon.minRequirement,
          validCoupon.maxAmount
        ),
        courier
      )
    );
  };

  const renderSidebar = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
        {loading && <></>}
        {error && <></>}
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-40">
            <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
              <NcImage src={thing.images[0]} />
            </div>
          </div>
          <div className="py-5 sm:px-5 space-y-3">
            <div>
              <span className="text-sm text-neutral-500 dark:text-neutral-400 max-w-md line-clamp-1">
                {thing.profile.displayName || ""}
              </span>
              <span className="text-base font-medium mt-1 block text-neutral-6000 dark:text-neutral-300">
                {thing.name || ""}
              </span>
            </div>

            <div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
            <StartRating
              reviewCount={thing.status.reviews.length || 0}
              point={thing.status.rating || 0}
            />
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold text-neutral-6000 dark:text-neutral-300">
            Total Biaya
          </h3>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>
              Rp {ongoingOrder ? formatRupiah(thing.price) : 1} x{" "}
              {ongoingOrder ? ongoingOrder.days : 1} malam
            </span>
            <span>
              Rp{" "}
              {ongoingOrder ? formatRupiah(thing.price * ongoingOrder.days) : 1}
            </span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Biaya pengiriman</span>
            <span>Rp {formatRupiah(pickUp.price + dropOff.price)}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Biaya layanan</span>
            <span>Rp {formatRupiah(3000)}</span>
          </div>
          {validCoupon._id && (
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>Kupon "{validCoupon.code}"</span>
              <span>
                Rp -{" "}
                {formatRupiah(
                  calculateCoupon(
                    thing.price,
                    validCoupon.percentage,
                    validCoupon.minRequirement,
                    validCoupon.maxAmount
                  )
                )}
              </span>
            </div>
          )}

          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold text-neutral-6000 dark:text-neutral-300">
            <span className="text-neutral-6000 dark:text-neutral-300">
              Total
            </span>
            <span>Rp {ongoingOrder ? formatRupiah(total) : 1}</span>
          </div>
        </div>
      </div>
    );
  };

  const renderConfirm = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
        {loading && <></>}
        {error && <></>}
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-20">
            <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl hidden sm:block overflow-hidden">
              <NcImage src={thing.images[0]} />
            </div>
          </div>
          <div className="py-5 sm:px-5 space-y-3">
            <div>
              <span className="text-sm text-neutral-500 dark:text-neutral-400 max-w-md line-clamp-1 hidden sm:block">
                {thing.profile.displayName || ""}
              </span>
              <span className="text-base font-medium mt-1 block text-neutral-6000 dark:text-neutral-300">
                {thing.name || ""}
              </span>
            </div>

            <div className="w-10 border-b border-neutral-200 hidden sm:block text-neutral-6000 dark:text-neutral-300 dark:border-neutral-700"></div>
            <StartRating
              className="hidden sm:flex text-neutral-6000 dark:text-neutral-300"
              reviewCount={thing.status.reviews.length || 0}
              point={thing.status.rating || 0}
            />
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold text-neutral-6000 dark:text-neutral-300">
            Total Biaya
          </h3>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>
              Rp {ongoingOrder ? formatRupiah(thing.price) : 1} x{" "}
              {ongoingOrder ? ongoingOrder.days : 1} malam
            </span>
            <span>
              Rp{" "}
              {ongoingOrder ? formatRupiah(thing.price * ongoingOrder.days) : 1}
            </span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Biaya pengiriman</span>
            <span>Rp {formatRupiah(pickUp.price + dropOff.price)}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Biaya layanan</span>
            <span>Rp {formatRupiah(3000)}</span>
          </div>
          {validCoupon._id && (
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>Kupon "{validCoupon.code}"</span>
              <span>
                Rp -{" "}
                {formatRupiah(
                  calculateCoupon(
                    thing.price,
                    validCoupon.percentage,
                    validCoupon.minRequirement,
                    validCoupon.maxAmount
                  )
                )}
              </span>
            </div>
          )}

          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold text-neutral-6000 dark:text-neutral-300">
            <span className="text-neutral-6000 dark:text-neutral-300">
              Total
            </span>
            <span>Rp {ongoingOrder ? formatRupiah(total) : 1}</span>
          </div>
        </div>
        <div className="flex justify-center justify-items-center mt-4">
          <div className="">
            <div className="mx-auto">
              <h3 className="text-base text-center font-semibold mb-4 text-neutral-6000 dark:text-neutral-400 sm:text-xl  ">
                Apakah Pesanan Sudah Sesuai?
              </h3>
            </div>
            <div className="flex justify-between gap-2 sm:gap-4">
              <ButtonSecondary onClick={handleOpen}>Kembali</ButtonSecondary>

              <ButtonPrimary onClick={handlePayment}>
                Lanjut Pembayaran
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMain = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold">
          Konfirmasi dan Pembayaran{" "}
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <div>
            <h3 className="text-2xl font-semibold">Barang Sewamu</h3>
            <NcModal
              renderTrigger={(openModal) => (
                <span
                  onClick={() => openModal()}
                  className="block lg:hidden underline  mt-1 cursor-pointer"
                >
                  View booking details
                </span>
              )}
              renderContent={renderSidebar}
            />
          </div>
          <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
            <div className="flex-1 p-5 flex justify-between space-x-5">
              <div className="flex flex-col">
                <span className="text-sm text-neutral-400">Dari</span>
                <span className="mt-1.5 text-lg font-semibold">
                  {ongoingOrder && moment(ongoingOrder.startDate).format("LL")}{" "}
                  : {ongoingOrder && ongoingOrder.startTime}
                </span>
              </div>
              {/* <PencilAltIcon className="w-6 h-6 text-neutral-300 dark:text-neutral-6000" /> */}
            </div>
            <div className="flex-1 p-5 flex justify-between space-x-5">
              <div className="flex flex-col">
                <span className="text-sm text-neutral-400">Sampai</span>
                <span className="mt-1.5 text-lg font-semibold">
                  {ongoingOrder && moment(ongoingOrder.endDate).format("LL")} :{" "}
                  {ongoingOrder && ongoingOrder.endTime}
                </span>
              </div>
              {/* <PencilAltIcon className="w-6 h-6 text-neutral-300 dark:text-neutral-6000" /> */}
            </div>
          </div>
        </div>

        <div className="space-y-8">
          <h3 className="text-2xl font-semibold">Lokasi Pengambilan Barang</h3>
          {dummyPickup.map((pickup, index) => {
            return (
              <FormItem key={index}>
                <input
                  name="pick-up"
                  type="radio"
                  className="focus:ring-primary-500 h-4 w-4 text-primary-500 border-neutral-300"
                  defaultChecked={index === 0 ? true : false}
                  onChange={() => {
                    setPickUp(pickup);
                  }}
                ></input>
                <span className="ml-3">
                  {pickup.name} :{" "}
                  {pickup.price
                    ? "Rp" + formatRupiah(pickup.price)
                    : "free ongkir"}
                </span>
              </FormItem>
            );
          })}

          {/* <FormItem label="Pilih Alamat">
            {addresses.length > 0 && (
              <ListBox
                data={addresses}
                onSelect={(e) => {
                  setPickUpLocation(e);
                }}
              />
            )}
          </FormItem>
          <div>
            <ButtonSecondary onClick={handleOpen}>
              Tambah Alamat Baru
            </ButtonSecondary>
          </div> */}
        </div>
        <div className="space-y-8">
          <h3 className="text-2xl font-semibold">Lokasi Pengembalian Barang</h3>
          {dummyPickup.map((dropoff, index) => {
            return (
              <FormItem key={index}>
                <input
                  name="drop-off"
                  type="radio"
                  className="focus:ring-primary-500 h-4 w-4 text-primary-500 border-neutral-300"
                  defaultChecked={index === 0 ? true : false}
                  onChange={() => {
                    setDropOff(dropoff);
                  }}
                ></input>
                <span className="ml-3">
                  {dropoff.name} :{" "}
                  {dropoff.price
                    ? "Rp" + formatRupiah(dropoff.price)
                    : "free ongkir"}
                </span>
              </FormItem>
            );
          })}

          {/* <FormItem label="Pilih Alamat">
            {addresses.length > 0 && (
              <ListBox
                data={addresses}
                onSelect={(e) => {
                  setDropOffLocation(e);
                }}
              />
            )}
          </FormItem>
          <div>
            <ButtonSecondary onClick={handleOpen}>
              Tambah Alamat Baru
            </ButtonSecondary>
          </div> */}
        </div>
        {/* <Modal open={open} handleOpen={handleOpen} title="Tambahkan Alamat">
          <Address
            modify={false}
            handleClose={handleOpen}
            handleSubmit={handleAddAddress}
          />
        </Modal> */}
        {/* <div>
          <h3 className="text-2xl font-semibold">Pay with</h3>
          <div className="mt-6">
            <Tab.Group>
              <Tab.List className="flex">
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-full focus:outline-none ${
                        selected
                          ? "bg-neutral-800 text-white"
                          : "text-neutral-6000 dark:text-neutral-400"
                      }`}
                    >
                      Paypal
                    </button>
                  )}
                </Tab>
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5  rounded-full flex items-center justify-center focus:outline-none  ${
                        selected
                          ? "bg-neutral-800 text-white"
                          : " text-neutral-6000 dark:text-neutral-400"
                      }`}
                    >
                      <span className="mr-2.5">Credit card</span>
                      <img className="w-8" src={visaPng} alt="" />
                      <img className="w-8" src={mastercardPng} alt="" />
                    </button>
                  )}
                </Tab>
              </Tab.List>

              <div className="w-14 border-b border-neutral-200 my-5"></div>
              <Tab.Panels>
                <Tab.Panel className="space-y-5">
                  <div className="space-y-1">
                    <Label>Card number </Label>
                    <Input defaultValue="111 112 222 999" />
                  </div>
                  <div className="space-y-1">
                    <Label>Card holder </Label>
                    <Input defaultValue="JOHN DOE" />
                  </div>
                  <div className="flex space-x-5  ">
                    <div className="flex-1 space-y-1">
                      <Label>Expiration date </Label>
                      <Input type="date" defaultValue="MM/YY" />
                    </div>
                    <div className="flex-1 space-y-1">
                      <Label>CVC </Label>
                      <Input />
                    </div>
                  </div>
                  <div className="space-y-1">
                    <Label>Messager for author </Label>
                    <Textarea placeholder="..." />
                    <span className="text-sm text-neutral-500 block">
                      Write a few sentences about yourself.
                    </span>
                  </div>
                  <div className="pt-4">
                    <ButtonPrimary>Confirm and pay</ButtonPrimary>
                  </div>
                </Tab.Panel>
                <Tab.Panel className="space-y-5">
                  <div className="space-y-1">
                    <Label>Email </Label>
                    <Input type="email" defaultValue="example@gmail.com" />
                  </div>
                  <div className="space-y-1">
                    <Label>Password </Label>
                    <Input type="password" defaultValue="***" />
                  </div>
                  <div className="space-y-1">
                    <Label>Messager for author </Label>
                    <Textarea placeholder="..." />
                    <span className="text-sm text-neutral-500 block">
                      Write a few sentences about yourself.
                    </span>
                  </div>
                  <div className="pt-4">
                    <ButtonPrimary>Confirm and pay</ButtonPrimary>
                  </div>
                </Tab.Panel>
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div> */}
        <div className="space-y-8">
          <h3 className="text-2xl font-semibold">Pengantaran</h3>
          <div>
            <FormItem className="flex">
              <input
                id="courier-radio"
                name="courier"
                type="radio"
                className="focus:ring-primary-500 h-4 w-4 text-primary-500 border-neutral-300"
                defaultChecked={true}
                value={courier}
                onChange={(e) => setCourier(e.target.value)}
              />
              <span className="ml-3">Kurir Toko</span>
            </FormItem>
            {/* <FormItem className="flex">
              <input
                id="courier-radio"
                name="courier"
                type="radio"
                className="focus:ring-primary-500 h-4 w-4 text-primary-500 border-neutral-300"
                defaultChecked={true}
                value={courier}
              />
              <span className="ml-3">Grab</span>
            </FormItem> */}
          </div>
        </div>
        <div className="pt-4">
          <ButtonPrimary onClick={handleOpen}>
            Konfirmasi dan bayar
          </ButtonPrimary>
        </div>
        <Modal
          open={open}
          handleOpen={handleOpen}
          title="Konfirmasi Pembayaran"
        >
          {renderConfirm()}
        </Modal>
      </div>
    );
  };

  const renderCoupon = () => {
    return (
      <div
        className={`w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 ${
          validCoupon._id && "border-green-700 bg-green-200"
        } space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8`}
      >
        {validCoupon._id ? (
          <div className="text-green-700">
            <h1 className="text-xl font-medium mb-2">
              Kupon <span className="font-bold">"{validCoupon.code}"</span>{" "}
              aktif
            </h1>
            <p className="text-sm">{validCoupon.description}</p>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-semibold">Kode Kupon</h1>
            <div className="relative">
              <Input
                fontClass=""
                sizeClass="h-16 px-4"
                rounded="rounded-3xl"
                placeholder="Masukkan kode kupon anda"
                value={coupon.value}
                onChange={(e) => {
                  setCoupon({ ...coupon, value: e.target.value });
                }}
              />
              <ButtonCircle
                className="absolute right-2 top-1/2 transform -translate-y-1/2"
                size=" w-12 h-12 "
                onClick={handleCoupon}
              >
                {coupon.loading ? (
                  <Loading center={true} />
                ) : (
                  <ArrowRightIcon className="w-5 h-5" />
                )}
              </ButtonCircle>
            </div>
            <span className="text-red-500 text-sm">{coupon.error}</span>
          </>
        )}
      </div>
    );
  };
  return (
    <div className={`nc-CheckOutPage ${className}`} data-nc-id="CheckOutPage">
      {alert && <Error>Masukkan Alamat</Error>}
      <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10 ">{renderMain()}</div>
        <div className="flex-grow">
          {" "}
          <div className="hidden lg:block flex-grow mb-5">
            {renderSidebar()}
          </div>
          <div className="hidden lg:block flex-grow">{renderCoupon()}</div>
        </div>
      </main>
    </div>
  );
};

export default CheckOutPage;
